import React from 'react';
import PropTypes from 'prop-types';
import UploadLink from '@Components/UploadLink';
import DragAndDrop from '@Components/DragAndDrop';
import { Flyout } from '@els/els-react--flyout';
import { ButtonWithIcon } from '@els/els-react--button';
import { Icon } from '@els/els-react--icon';
import noop from 'lodash/noop';

import '../ImportFileModal.scss';

function ImportFileModalContent(props) {
  const { uploadedFile, importFile, isRt } = props;
  return (
    <div className="import-file-modal__content">
      <div className="import-file-modal__content_title">
        {isRt && (
          <div className="import-file-modal__content_tooltip">
            <span>Import target molecules</span>
            <Flyout
              flyout="Reaxys supports the import of files containing up to 20 SMILES strings or Molfiles"
              shouldCloseOnESC
              width="25rem"
              trigger="hover"
              placement="bottom-end"
              pointerType="primary">
              <ButtonWithIcon
                sprite="InformationOutlineCircle"
                linkIconSize="xs"
                iconOnly
                onClick={noop}
                type="link"
                aria-label="Information: Reaxys supports the import of files containing up to 20 SMILES strings or Molfiles">
                Information Text
              </ButtonWithIcon>
            </Flyout>
          </div>
        )}
        {!isRt && <span className="u-els-font-family-base">Import a previously saved Reaxys query</span>}
      </div>

      {!uploadedFile && (
        <DragAndDrop className="import-file-modal__content_drop" onDrop={importFile}>
          <div className="import-file-modal__content_drop_div">
            <div className="import-file-modal__content_drop_div">
              <p className="import-file-modal__content_drop_text">Drag and drop your files here or</p>
              <div className="import-file-modal__content_drop_text">
                <UploadLink onChange={importFile} label="Browse files" />
              </div>
            </div>
          </div>
        </DragAndDrop>
      )}
      {uploadedFile && (
        <div className="import-file-modal__content_result">
          <Icon sprite="TextFile" isVisible aria-label={`file imported - ${uploadedFile.name}`}>
            {uploadedFile.name}
          </Icon>
        </div>
      )}
    </div>
  );
}

ImportFileModalContent.propTypes = {
  importFile: PropTypes.func.isRequired,
  uploadedFile: PropTypes.object,
  isRt: PropTypes.bool,
};

export default ImportFileModalContent;
